import { render, staticRenderFns } from "./main_records.vue?vue&type=template&id=cd9b3f4e&scoped=true&"
import script from "./main_records.vue?vue&type=script&lang=js&"
export * from "./main_records.vue?vue&type=script&lang=js&"
import style0 from "./main_records.vue?vue&type=style&index=0&id=cd9b3f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9b3f4e",
  null
  
)

export default component.exports